import { Box } from '@mui/material';
import { FC } from 'react';
import { LabeledSectionSkeleton } from '../labeled-section/labeled-section.skeleton';
import { LabeledTextSkeleton } from '../labeled-text/labeled-text.skeleton';

export const InsuranceInfoSectionSkeleton: FC = () => {
  return (
    <LabeledSectionSkeleton labelWidth={140}>
      <LabeledTextSkeleton labelWidth={120} textWidth={100} />
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <LabeledTextSkeleton labelWidth={130} textWidth={80} sx={{ flex: 1 }} />
        <LabeledTextSkeleton labelWidth={120} textWidth={80} sx={{ flex: 1 }} />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <LabeledTextSkeleton labelWidth={70} textWidth={100} sx={{ flex: 1 }} />
        <LabeledTextSkeleton labelWidth={140} textWidth={80} sx={{ flex: 1 }} />
      </Box>
    </LabeledSectionSkeleton>
  );
};
